import { BLOG_CATEGORIES, BLOG_POSTS } from "../data/blogPosts";

export const POSTS_PER_PAGE = 99;

export function getCategories() {
  return BLOG_CATEGORIES;
}

export function getCategoryBySlug(slug) {
  return BLOG_CATEGORIES.find((c) => c.slug === slug) || null;
}

export function getCategoryName(slug) {
  const category = getCategoryBySlug(slug);
  return category ? category.name : slug;
}

export function formatPublishDate(dateStr) {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function getAllPosts() {
  return [...BLOG_POSTS].sort(
    (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
  );
}

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((post) => post.slug === slug) || null;
}

export function getPopularPosts(limit = 4) {
  const popular = getAllPosts().filter((post) => post.popular);
  if (popular.length >= limit) return popular.slice(0, limit);
  return getAllPosts().slice(0, limit);
}

export function getRelatedPosts(post, limit = 3) {
  if (!post) return [];
  const sameCategory = getAllPosts().filter(
    (p) => p.category === post.category && p.slug !== post.slug
  );
  if (sameCategory.length >= limit) return sameCategory.slice(0, limit);
  const extras = getAllPosts().filter(
    (p) => p.slug !== post.slug && !sameCategory.some((s) => s.slug === p.slug)
  );
  return [...sameCategory, ...extras].slice(0, limit);
}

export function filterPosts({ category = "all", search = "" } = {}) {
  const query = search.trim().toLowerCase();
  return getAllPosts().filter((post) => {
    const categoryMatch =
      category === "all" || !category || post.category === category;
    if (!categoryMatch) return false;
    if (!query) return true;
    const haystack = [
      post.title,
      post.excerpt,
      post.author,
      getCategoryName(post.category),
      ...(post.content || [])
        .map((block) => block.text || (block.items || []).join(" "))
        .filter(Boolean),
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(query);
  });
}

export function paginatePosts(posts, page = 1, perPage = POSTS_PER_PAGE) {
  const total = posts.length;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = (currentPage - 1) * perPage;
  return {
    items: posts.slice(start, start + perPage),
    total,
    totalPages,
    currentPage,
    perPage,
  };
}
